import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { BreakPointDesktop } from "../../../constants/dimension";
import { isTV } from "../../../utils/platform";

export const useStyles = createUseStyles((theme: ITheme) => {
  const itemSelected = {
    position: "relative",
    cursor: "pointer",
    pointerEvents: "auto",
    zIndex: 0,
    borderRadius: theme.spacing.space20,
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      boxSizing: "border-box",
      pointerEvents: "none",
      zIndex: 1,
      borderRadius: theme.spacing.space24,
      padding: 3,
      margin: -6,
      ...(isTV
        ? {
            border: "2px solid rgba(255, 255, 255, 0.6)",
            maskComposite: "xor",
          }
        : {
            backgroundColor: "rgba(255, 255, 255, 0.4)",
            backgroundImage:
              "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.6) 20%, rgba(255, 255, 255, 0.2) 55%, rgba(255, 255, 255, 0.2) 100%, rgba(255, 255, 255, 0.5) 80%, rgba(255, 255, 255, 0.9) 100%)",
            WebkitMask:
              "linear-gradient(#000 0 0) padding-box, linear-gradient(#000 0 0) content-box",
            WebkitMaskComposite: "xor",
            mask: "linear-gradient(#000 0 0) padding-box, linear-gradient(#000 0 0) content-box",
            maskComposite: "exclude",
            transition:
              "padding 0.3s ease, margin 0.3s ease, opacity 0.3s ease",
          }),
    },
  };

  return {
    navigationBar: {
      scrollPaddingInline: "32px",
      WebkitOverflowScrolling: "touch",
      overscrollBehaviorX: "contain",
      flexDirection: "row",
      alignItems: "center",
      height: "auto",
      overflow: "scroll",
      overflowX: "scroll",
      overflowY: "hidden",
      position: "fixed !important",
      top: 0,
      width: "100vw",
      boxSizing: "border-box",
      zIndex: theme.zIndex.appBar,
      display: "flex",
      "-ms-overflow-style": "none" /* IE and Edge */,
      scrollbarWidth: "none" /* Firefox */,
      /* Hide scrollbar for Chrome, Safari and Opera */
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    navInner: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      overflow: "scroll",
      boxSizing: "border-box",
      "-ms-overflow-style": "none",
      scrollbarWidth: "none",
      scrollPaddingInline: "90px",
      "&::-webkit-scrollbar": {
        display: "none",
      },
      padding: `40px 90px`,
      gap: theme.spacing.space32,
      "& > div:nth-of-type(2)": {
        marginLeft: -75,
      },
      "& > div:nth-last-of-type(2)": {
        marginRight: -75,
      },
    },
    hover: {
      "&:hover": {
        transform: "scale(1.06)",
        position: "relative",
        cursor: "pointer",
        borderRadius: theme.spacing.space20,
      },
    },
    notAtTop: {
      background:
        "linear-gradient(180deg, #000 60%, rgba(0, 0, 0, 0.80) 69.98%, rgba(0, 0, 0, 0.00) 100%)",
    },
    singleRoot: {
      position: "fixed",
      zIndex: theme.zIndex.appBar,
      width: "100%",
      top: 0,
    },
    singleNav: {
      background: "rgba(255, 255, 255, 0.10) !important",
      ...(!isTV && { backdropFilter: "blur(24.545454025268555px)" }),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: 48,
      width: 48,
      margin: `${theme.spacing.space24}px ${theme.spacing.space16}px`,
      borderRadius: theme.radius.small,
      [BreakPointDesktop]: {
        height: 96,
        width: 96,
        margin: `${theme.spacing.space40}px ${
          theme.spacing.space40 * 2 + 10
        }px`,
        borderRadius: theme.radius.large - theme.radius.sSmall,
      },
    },
    content: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      background: "rgba(255, 255, 255, 0.10)",
      backdropFilter: "blur(24.545454025268555px)",
      cursor: "pointer",
      gap: theme.spacing.space8,
      padding: `8px 16px 8px 8px`,
      borderRadius: theme.spacing.space20,
    },
    icon: {
      cursor: "pointer",
      height: "fit-content",
      background: "rgba(255, 255, 255, 0.10)",
      ...(!isTV && { backdropFilter: "blur(24.545454025268555px)" }),
      width: "auto !important",
      borderRadius: theme.spacing.space20,
      padding: "12px !important",
    },
    itemSelected,
    itemSelectedMain: { ...itemSelected },
    itemSelectedMainScrolled: {
      transform: "scale(1.06)",
      background: isTV ? "#4D4D4D" : "rgba(255, 255, 255, 0.30)",
      cursor: "pointer",
    },
    imgGame: {
      objectFit: "cover",
      border: "0px solid transparent",
      position: "relative",
      width: 72,
      height: 96,
      borderRadius: theme.spacing.space20,
    },
    nameSelected: {
      lineHeight: "normal !important",
    },
    imgPage: {
      objectFit: "cover",
      width: 80,
      height: 80,
    },
    iconSize: {
      fontSize: `48px !important`,
    },
    sizeImage: {
      cursor: "pointer",
      width: `52px !important`,
      height: `52px !important`,
      padding: 10,
    },
    gameLastActiveDot: {
      content: '""',
      position: "absolute",
      top: 8,
      right: 8,
      width: 12,
      height: 12,
      borderRadius: "50%",
      background: "#22c55e",
    },
    hourGlassBadge: {
      position: "absolute",
      zIndex: 2,
      top: -10,
      right: -10,
      width: 25,
      height: 25,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      color: "#FFFFFF",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.45)",
      ...(isTV
        ? {
            background: "rgba(38, 38, 38, 0.92)",
            border: "1.5px solid rgba(255, 255, 255, 0.14)",
          }
        : {
            background:
              "linear-gradient(rgba(38, 38, 38, 0.92), rgba(38, 38, 38, 0.92)) padding-box, linear-gradient(135deg, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.05) 100%) border-box",
            border: "1.5px solid transparent",
            backdropFilter: "blur(6px)",
          }),
    },
    iconMatched: {
      background: "rgba(255, 255, 255, 0.10)",
      width: 80,
      height: 80,
      borderRadius: theme.spacing.space24,
    },
    aaaLogo: {
      paddingRight: theme.spacing.space16,
    },
    active: {
      outline: `2px solid ${theme.colors.Border4}`,
      outlineOffset: 2,
    },
    tabName: {
      width: "max-content",
    },
  };
});
